import { render, staticRenderFns } from "./ContentPreview.vue?vue&type=template&id=0920e174&scoped=true&lang=pug&"
import script from "./ContentPreview.vue?vue&type=script&lang=js&"
export * from "./ContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./ContentPreview.vue?vue&type=style&index=0&id=0920e174&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920e174",
  null
  
)

export default component.exports